import React, { FC } from "react";
import { View, Text } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import { AssetQuestion } from "../../../../Questionnaires.types";
import { styles } from "../../PdfDocument.styled";

interface Questions {
  questions: AssetQuestion[];
  mainRelevantYear?: string;
}

const Questions: FC<Questions> = ({ questions, mainRelevantYear }) => {
  const { t } = useTranslation();

  return questions.map(
    (q: AssetQuestion, index: number): React.ReactElement => (
      <View key={`${q.number}-${index}`} style={styles.section}>
        <Text style={styles.question}>
          ({index + 1}) {q.text}
        </Text>
        <Text style={styles.answer}>
          {t("csob.pdf.answer")}: {q.answer}
        </Text>
        {q.answer && (q.relevantYear || mainRelevantYear) && (
          <Text style={styles.relevantYear}>
            {t("csob.pdf.relevantYear")}: {q.relevantYear || mainRelevantYear}
          </Text>
        )}
        {q.comment && (
          <Text style={styles.comment}>
            {t("csob.pdf.comment")}: {q.comment}
          </Text>
        )}
      </View>
    ),
  );
};

export default Questions;
